module.exports = __webpack_public_path__ + "img/sw-face-lg.ca49c43e.webp";